<template>
  <div class="app-number-block">{{ number }}</div>
</template>

<script>
export default {
  props: ["number"],
};
</script>

<style scoped>
.app-number-block {
  -ms-touch-action: none;
  touch-action: none;
  background: #4e4;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 25px;
  height: 45px;
  width: 45px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: solid 1px #7f8c8d;
  border-radius: 0.4vw;
  text-align: center;
  display: inline-block;
}
.app-number-block:hover {
  background: #eeeeee;
}
</style>